import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createSlots as _createSlots, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-9d4f373c")

_pushScopeId("data-v-9d4f373c")
const _hoisted_1 = /*#__PURE__*/_createVNode("label", {
  style: {"color":"#ff4949"},
  class: "margin-right5px"
}, "*", -1)
const _hoisted_2 = { style: {"color":"#606266"} }
const _hoisted_3 = { class: "popover-text" }
const _hoisted_4 = { class: "display-flex" }
const _hoisted_5 = { class: "p-left-right-sm" }
const _hoisted_6 = { class: "p-left-right-sm" }
const _hoisted_7 = {
  key: 2,
  style: {"color":"red"}
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_cus_option = _resolveComponent("cus-option")
  const _component_cus_select = _resolveComponent("cus-select")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_question_tip = _resolveComponent("question-tip")
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_checkbox = _resolveComponent("el-checkbox")
  const _component_el_form = _resolveComponent("el-form")

  return (_openBlock(), _createBlock(_component_el_form, {
    "label-position": _ctx.$formLabelPosition,
    ref: "formEle",
    model: _ctx.basicData,
    rules: _ctx.rules,
    class: "set-page-form-width"
  }, {
    default: _withId(() => [
      _createVNode(_component_el_form_item, {
        label: _ctx.$wordList.ProperAllTextDepartment,
        prop: "DepartmentID"
      }, {
        default: _withId(() => [
          _createVNode(_component_cus_select, {
            modelValue: _ctx.basicData.DepartmentID,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.basicData.DepartmentID = $event)),
            style: {"width":"100%"},
            disabled: !!_ctx.id,
            onChange: _ctx.saveFloor
          }, {
            default: _withId(() => [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.buildOptions, (item) => {
                return (_openBlock(), _createBlock(_component_cus_option, {
                  key: item,
                  value: item.key,
                  label: item.value
                }, null, 8, ["value", "label"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["modelValue", "disabled", "onChange"])
        ]),
        _: 1
      }, 8, ["label"]),
      _createVNode(_component_el_form_item, null, {
        default: _withId(() => [
          _createVNode("p", null, [
            _hoisted_1,
            _createVNode("label", _hoisted_2, _toDisplayString(_ctx.$wordList.ProperAllTextIdentity), 1),
            _createVNode(_component_question_tip, {
              placement: "top-start",
              class: "margin-left10px",
              "self-class": 'question-height30px'
            }, {
              default: _withId(() => [
                _createVNode("p", _hoisted_3, _toDisplayString(_ctx.$wordList.PeopleIdentityTips), 1)
              ]),
              _: 1
            })
          ]),
          _createVNode("div", _hoisted_4, [
            _createVNode(_component_cus_select, {
              modelValue: _ctx.basicData.Role,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.basicData.Role = $event)),
              style: {"width":"100%"}
            }, {
              default: _withId(() => [
                _createVNode(_component_cus_option, {
                  value: "30",
                  label: _ctx.$wordList.BasicUser
                }, null, 8, ["label"]),
                _createVNode(_component_cus_option, {
                  value: "31",
                  label: _ctx.$wordList.AdvancedUser
                }, null, 8, ["label"])
              ]),
              _: 1
            }, 8, ["modelValue"])
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_el_form_item, {
        label: _ctx.$wordList.TabelPropertyManageFirstName,
        prop: "FirstName"
      }, {
        default: _withId(() => [
          _createVNode(_component_el_input, {
            modelValue: _ctx.basicData.FirstName,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.basicData.FirstName = $event))
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      }, 8, ["label"]),
      _createVNode(_component_el_form_item, {
        label: _ctx.$wordList.TabelPropertyManageLastName,
        prop: "LastName"
      }, {
        default: _withId(() => [
          _createVNode(_component_el_input, {
            modelValue: _ctx.basicData.LastName,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.basicData.LastName = $event))
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      }, 8, ["label"]),
      _createVNode(_component_el_form_item, {
        label: _ctx.$wordList.ProperAllTextID,
        prop: "EmployeeID"
      }, {
        default: _withId(() => [
          _createVNode(_component_el_input, {
            modelValue: _ctx.basicData.EmployeeID,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.basicData.EmployeeID = $event))
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      }, 8, ["label"]),
      _createVNode(_component_el_form_item, {
        label: _ctx.$wordList.TabelPropertyManageEmail,
        prop: "Email"
      }, {
        default: _withId(() => [
          _createVNode(_component_el_input, {
            modelValue: _ctx.basicData.Email,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.basicData.Email = $event)),
            disabled: _ctx.basicData.IsMulti === 1
          }, null, 8, ["modelValue", "disabled"])
        ]),
        _: 1
      }, 8, ["label"]),
      _createVNode(_component_el_form_item, {
        label: _ctx.$wordList.ProperAllTextCountryRegion,
        prop: "PhoneCode"
      }, {
        default: _withId(() => [
          _createVNode(_component_cus_select, {
            modelValue: _ctx.basicData.PhoneCode,
            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.basicData.PhoneCode = $event)),
            filter: "",
            style: {"width":"100%"},
            disabled: _ctx.isCNServer || _ctx.basicData.IsMulti === 1
          }, {
            default: _withId(() => [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.getPhoneCodeOps(), (item) => {
                return (_openBlock(), _createBlock(_component_cus_option, {
                  key: item,
                  value: item.value,
                  label: item.label
                }, null, 8, ["value", "label"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["modelValue", "disabled"])
        ]),
        _: 1
      }, 8, ["label"]),
      _createVNode(_component_el_form_item, {
        label: _ctx.$wordList.ProperAllTextMobileNumber,
        prop: "MobileNumber"
      }, {
        default: _withId(() => [
          _createVNode(_component_el_input, {
            modelValue: _ctx.basicData.MobileNumber,
            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.basicData.MobileNumber = $event)),
            disabled: _ctx.basicData.IsMulti === 1,
            onInput: _ctx.limitMobileNumberType
          }, _createSlots({ _: 2 }, [
            (_ctx.basicData.PhoneCode)
              ? {
                  name: "prepend",
                  fn: _withId(() => [
                    _createVNode("span", _hoisted_5, " +" + _toDisplayString(_ctx.basicData.PhoneCode), 1)
                  ])
                }
              : undefined
          ]), 1032, ["modelValue", "disabled", "onInput"])
        ]),
        _: 1
      }, 8, ["label"]),
      (_ctx.basicData.HasIntercomAccess=='1')
        ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
            (_ctx.EnableLandLine==1)
              ? (_openBlock(), _createBlock(_component_el_form_item, {
                  key: 0,
                  label: _ctx.$wordList.LandlineNumber
                }, {
                  default: _withId(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.basicData.Phone,
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.basicData.Phone = $event))
                    }, _createSlots({ _: 2 }, [
                      (_ctx.basicData.PhoneCode)
                        ? {
                            name: "prepend",
                            fn: _withId(() => [
                              _createVNode("span", _hoisted_6, " +" + _toDisplayString(_ctx.basicData.PhoneCode), 1)
                            ])
                          }
                        : undefined
                    ]), 1032, ["modelValue"])
                  ]),
                  _: 1
                }, 8, ["label"]))
              : _createCommentVNode("", true)
          ], 64))
        : _createCommentVNode("", true),
      (_ctx.id)
        ? (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
            _createVNode(_component_el_form_item, {
              label: _ctx.$wordList.ProperAllTextCallType
            }, {
              default: _withId(() => [
                _createVNode(_component_cus_select, {
                  modelValue: _ctx.basicData.CallType,
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.basicData.CallType = $event)),
                  style: {"width":"100%"}
                }, {
                  default: _withId(() => [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.callTypeOptions, (item) => {
                      return (_openBlock(), _createBlock(_component_cus_option, {
                        key: item.value,
                        value: item.value,
                        label: item.label
                      }, null, 8, ["value", "label"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_form_item, {
              label: _ctx.$wordList.ProperAllTextSipIpCall
            }, {
              default: _withId(() => [
                _createVNode(_component_cus_select, {
                  modelValue: _ctx.basicData.EnableIpDirect,
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.basicData.EnableIpDirect = $event)),
                  style: {"width":"100%"}
                }, {
                  default: _withId(() => [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.sipCallOptions, (item) => {
                      return (_openBlock(), _createBlock(_component_cus_option, {
                        key: item.value,
                        value: item.value,
                        label: item.label
                      }, null, 8, ["value", "label"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["label"])
          ], 64))
        : _createCommentVNode("", true),
      (_ctx.isShowExpireTip)
        ? (_openBlock(), _createBlock("p", _hoisted_7, _toDisplayString(_ctx.$wordList.ProperAllTextFeatureExpireTips), 1))
        : _createCommentVNode("", true),
      _createVNode(_component_el_form_item, null, {
        default: _withId(() => [
          _createVNode(_component_el_checkbox, {
            modelValue: _ctx.basicData.TempKeyPermission,
            "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (_ctx.basicData.TempKeyPermission = $event)),
            onChange: _ctx.changeUserQRCode,
            "true-label": '1',
            "false-label": '0'
          }, {
            default: _withId(() => [
              _createTextVNode(_toDisplayString(_ctx.$wordList.ProperAllTextAllowedCreateQRCodes), 1)
            ]),
            _: 1
          }, 8, ["modelValue", "onChange"])
        ]),
        _: 1
      }),
      _createVNode(_component_el_form_item, null, {
        default: _withId(() => [
          _createVNode(_component_el_checkbox, {
            modelValue: _ctx.basicData.RegisterFaceControl,
            "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (_ctx.basicData.RegisterFaceControl = $event)),
            "true-label": '1',
            "false-label": '0'
          }, {
            default: _withId(() => [
              _createTextVNode(_toDisplayString(_ctx.$wordList.RegisterFaceID), 1)
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["label-position", "model", "rules"]))
})